import { AbstractControl, ValidationErrors } from '@angular/forms';
import { GroupValidation } from '@softline/core';

export const END_DAY_MISMATCH = 'endDayMismatch';
export const END_BEFORE_START = 'endBeforeStart';

/**
 * Roster entries are per day: Enddatum must equal Startdatum, and the end must not be
 * before the start. Returns GroupValidations keyed on the end fields so
 * `softFieldValidation` shows them there. day = `YYYY-MM-DD`, time = `HH:mm`.
 */
export function calendarEventValidator(
  control: AbstractControl
): ValidationErrors | null {
  const beginDay = control.get('beginDay')?.value as string | null;
  const beginTime = control.get('beginTime')?.value as string | null;
  const endDay = control.get('endDay')?.value as string | null;
  const endTime = control.get('endTime')?.value as string | null;

  if (beginDay && endDay && beginDay !== endDay) {
    return {
      [END_DAY_MISMATCH]: groupValidation(
        ['endDay'],
        'Enddatum muss dem Startdatum entsprechen (ein Planeintrag pro Tag).'
      ),
    };
  }
  if (!beginDay || !beginTime || !endDay || !endTime) return null;

  const start = new Date(`${beginDay}T${beginTime}`).getTime();
  const end = new Date(`${endDay}T${endTime}`).getTime();
  if (Number.isNaN(start) || Number.isNaN(end) || end >= start) return null;
  return {
    [END_BEFORE_START]: groupValidation(
      ['endDay', 'endTime'],
      'Das Ende darf nicht vor dem Beginn liegen.'
    ),
  };
}

function groupValidation(properties: string[], message: string): GroupValidation {
  return {
    isValid: false,
    properties,
    messages: [{ subject: properties[0], type: 'error', message }],
  };
}
